import Icon from 'components/Icon/Icon';

import styles from './DatePicker.module.scss';

const DatePickerHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
}: {
  date: Date;
  decreaseMonth: () => void;
  increaseMonth: () => void;
}) => {
  const dateTitle = date.toLocaleString('en-US', {
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className={styles['datepicker-nav']}>
      <button
        type="button"
        className={styles['datepicker-change-month-prev']}
        onClick={decreaseMonth}
      >
        <Icon
          name="arrow-circle-right"
          className={styles['datepicker-change-month-prev-icon']}
        />
      </button>
      <span className={styles['datepicker-month-title']}>{dateTitle}</span>
      <button
        className={styles['datepicker-change-month-next']}
        type="button"
        onClick={increaseMonth}
      >
        <Icon
          name="arrow-circle-right"
          className={styles['datepicker-change-month-next-icon']}
        />
      </button>
    </div>
  );
};

export default DatePickerHeader;
